import angular from 'angular';
import display from './builder/display.html';
import conditional from './builder/conditional.html';

angular.module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/panel/display.html', display);
	$templateCache.put('kform/components/panel/conditional.html', conditional);
});
